import IContentfulButton from './IContentfulButton';
import { ButtonSizeType } from '../../constants/button-size-type';
import { ButtonStyleType } from '../../constants/button-style-type';
import colorStyle from '../../styles/utils/variables.module.scss';
import { ApplicationBranding } from '../../models/settings';
import { replaceAttrSpaceWithHyphen } from '../../utils/string-helpers/replace-attr-space-with-hyphen';
import { Ref } from 'react';

export default class IButton {
  buttonID?: string;
  buttonURL?: string;
  buttonNewTab?: string;
  buttonAriaLabel?: string;
  buttonRole?: string;
  buttonName?: string;
  buttonSize?: ButtonSizeType;
  buttonStyle: ButtonStyleType;
  copyColor: string;
  backgroundColor: string;
  hoverBackgroundColor: string;
  activeBackgroundColor: string;
  outlineColor?: string;
  /** added button style and type string literals to specify exact values,
   * with a union type to join them together */
  buttonType?: `button` | `submit` | `reset`;
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  heapIdentifier?: any;
  customClass?: string;
  ref?: Ref<HTMLButtonElement | HTMLAnchorElement>;

  constructor(
    button: IContentfulButton,
    appBranding: ApplicationBranding,
    buttonSize?: ButtonSizeType,
    buttonStyle?: ButtonStyleType,
  ) {
    const isButtonOutlineStyled = buttonStyle === ButtonStyleType.Outline;

    this.buttonID = button.fields.id
      ? button.fields.id
      : replaceAttrSpaceWithHyphen(button.fields.buttonName);
    this.buttonURL = button.fields.url;
    this.buttonNewTab = button.fields.target;
    this.buttonAriaLabel = button.fields.buttonName;
    this.buttonName = button.fields.buttonName;
    this.copyColor = isButtonOutlineStyled ? appBranding.primaryColor : colorStyle.white;
    this.backgroundColor = isButtonOutlineStyled ? colorStyle.white : appBranding.primaryColor;
    this.outlineColor = appBranding.primaryColor;
    this.hoverBackgroundColor = appBranding.primaryHoverColor;
    this.activeBackgroundColor = appBranding.primaryActiveColor;
    this.children = `${button.fields.text}`;
    this.buttonType = 'button';
    this.buttonSize = button.fields.buttonSize as ButtonSizeType;
    this.buttonStyle = button.fields.buttonStyle as ButtonStyleType;
    this.heapIdentifier = button.fields.id
      ? button.fields.id
      : replaceAttrSpaceWithHyphen(button.fields.buttonName);
  }
}
